export default __webpack_public_path__ + "static/media/raspberry_yoghurt_swirl.0c8e2470.png";